import { Heading } from '@acb_devel/design-system';
import {
  ArrowsUpDownIcon,
  ArrowUpIcon,
  ArrowDownIcon,
} from '@acb_devel/design-system';
import { Skeleton } from '@acb_devel/design-system';

import styles from './DataTable.module.scss';

export function DataTable<T>({
  data,
  sortKey,
  direction,
  loading,
  onRowClick,
  onSort,
  columns,
}: {
  data: T[];
  sortKey?: string;
  direction?: 'asc' | 'desc';
  loading: boolean;
  onRowClick?: (row: T) => void;
  onSort?: (sortKey: string, direction: 'asc' | 'desc') => void;
  columns: {
    sortKey: string;
    label: string;
    render: (row: T) => JSX.Element;
  }[];
}) {
  return (
    <table className={styles.table}>
      <thead className={styles.table__header}>
        <tr>
          {columns.map((column, index) => (
            <th
              key={index}
              className={styles.table__th}
              onClick={() => {
                if (column.sortKey === sortKey && direction === 'desc') {
                  return onSort?.('', 'asc');
                }

                if (column.sortKey !== sortKey) {
                  return onSort?.(column.sortKey, 'asc');
                }

                return onSort?.(
                  column.sortKey,
                  direction === 'asc' ? 'desc' : 'asc'
                );
              }}
            >
              <Heading
                as="h4"
                variant="subhead"
                className={styles.table__heading}
              >
                {column.label}
                <>
                  {sortKey !== column.sortKey && <ArrowsUpDownIcon />}
                  {sortKey === column.sortKey && direction === 'asc' && (
                    <ArrowUpIcon />
                  )}
                  {sortKey === column.sortKey && direction === 'desc' && (
                    <ArrowDownIcon />
                  )}
                </>
              </Heading>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {!loading && data.length === 0 && (
          <tr>
            <td
              colSpan={columns.length}
              className={styles.table__td}
              align="center"
            >
              <Heading as="h4" variant="subhead">
                Sin resultados
              </Heading>
            </td>
          </tr>
        )}
        {data.length > 0 && (
          <>
            {data.map((row, index) => (
              <tr
                key={index}
                className={styles.table__tr}
                onClick={() => onRowClick?.(row)}
                data-clickable={!!onRowClick}
              >
                {columns.map((column, index) => (
                  <td key={index} className={styles.table__td}>
                    <Skeleton loading={loading}>{column.render(row)}</Skeleton>
                  </td>
                ))}
              </tr>
            ))}
          </>
        )}
      </tbody>
    </table>
  );
}
